import { Flex, Typography } from 'antd';
import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { BlackButton } from 'common/components/UI';
import { ROUTES } from 'common/components/AppRouter/AppRouter';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

type Step2Props = {
  amount: number,
  resetForm: () => unknown
}

const Success: React.FC<Step2Props> = ({
  amount,
  resetForm
}) => {
  const { formatMessage: t } = useIntl();
  const navigate = useNavigate();

  return (
    <Flex vertical align="center" gap={32}>
      <Flex vertical align="center" gap={16}>
        <Flex justify="center" align="center" style={{
          borderRadius: '50%',
          backgroundColor: '#1EC624',
          width: 80,
          height: 80,
        }}>
          <CheckOutlined style={{ color: 'white', fontSize: 40 }} />
        </Flex>
        <Flex vertical align="center">
          <Text strong style={{ fontSize: 20 }}>
            {t({ id: 'screens.c2cpayment.create.completed.messages.success1' }, {amount})}
          </Text>
          <Text strong style={{ fontSize: 20 }} id='text__send-between-accounts-success'>
            {t({ id: 'screens.c2cpayment.create.completed.messages.success2' })}
          </Text>
        </Flex>
      </Flex>
      <BlackButton id='btn__send-between-accounts-success' onClick={() => {
        resetForm();
        navigate(ROUTES.RIVER_SEND.path)
      }} type="primary"
      >
        {t({ id: 'sections.send.swift.success.button' })}
      </BlackButton>
    </Flex>
  );
};

export default Success;